import React from 'react';
import {
  List, ListItemButton, ListItemIcon, ListItemText,
} from '@mui/material';
import ImpoundLotIcon from '@mui/icons-material/CarCrash';
import KeyIcon from '@mui/icons-material/Key';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NoCrashIcon from '@mui/icons-material/NoCrash';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../../common/components/LocalizationProvider';
import { ReactComponent as TowingIcon } from '../../resources/images/data/recovery.svg';

const MenuItem = ({
  title, link, icon, selected,
}) => (
  <ListItemButton key={link} component={Link} to={link} selected={selected}>
    <ListItemIcon>{icon}</ListItemIcon>
    <ListItemText primary={title} />
  </ListItemButton>
);

const ToolsMenu = () => {
  const t = useTranslation();
  const location = useLocation();

  return (
    <List>
      <MenuItem
        title={t('toolsFindRecovery')}
        link="/tools/find-recovery"
        icon={<ImpoundLotIcon />}
        selected={location.pathname === '/tools/find-recovery'}
      />
      <MenuItem
        title={t('toolsFindTowing')}
        link="/tools/find-towing"
        icon={<TowingIcon />}
        selected={location.pathname === '/tools/find-towing'}
      />
      <MenuItem
        title={t('toolsFindAuction')}
        link="/tools/find-auction"
        icon={<NoCrashIcon />}
        selected={location.pathname === '/tools/find-auction'}
      />
      <MenuItem
        title={t('toolsFindLocksmith')}
        link="/tools/find-locksmith"
        icon={<KeyIcon />}
        selected={location.pathname === '/tools/find-locksmith'}
      />
      <MenuItem
        title={t('toolsFindGPSInstaller')}
        link="/tools/find-gpsinstaller"
        icon={<LocationOnIcon />}
        selected={location.pathname === '/tools/find-gpsinstaller'}
      />
    </List>
  );
};

export default ToolsMenu;
